'use strict';

import BamGameUtils from 'bam-game-utils';
const BamButton = BamGameUtils.getBamButtonClass();

/**
 * Subclass of BamButton.  At present, we don't override any of its functionality.
 * @extends BamButton
 */
class MlbButton extends BamButton {
    /**
     *
     * @param url The URL associated with the button. Required.
     * @param label The (language-specific) label for this button (pass null if n/a). Optional.
     * @param glyphiconCode The code associated with this button's Glyphicon, used to build a CSS class.  Optional.
     * @param targetAttr The link's "target" attr; accepted values are "_self" and "_blank". Optional; default
     *   is "_self".
     * @param supplementaryData An object containing extra data needed to render this button; the object's keys and
     *   general structure are button-type-dependent
     * @constructor
     */
    constructor(url, label, glyphiconCode, targetAttr, supplementaryData, ariaLabel) {
        super(url, label, glyphiconCode, targetAttr, supplementaryData);
        this.ariaLabel = ariaLabel || null;
    }

    toString() {
        let s = '{';
        for (let key in this) {
            if (this.hasOwnProperty(key) && key.indexOf('_') !== 0) {
                s += key + '=' + this[key] + ';';
            }
        }
        if (s.length > 1) {
            s = s.substring(0, s.length - 1);
        }
        s += '}';
        return s;
    }

    get buttonProps() {
        return {
            url: this.url,
            text: this.text,
            icon: this.icon,
            target: this.target,
            ariaLabel: this.ariaLabel,
            supplementaryData: this.supplementaryData
        };
    }
}

export default MlbButton;

